const _excluded = ["className", "linkTo"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import { Card } from 'seagull';
import styles from "./GraphWidgetTopCard.module.scss";
import { Link } from 'react-router-dom';
/** Renders a card for the 1st row of a graph widget. */
export default function GraphWidgetTopCard(props) {
  const {
      className,
      linkTo
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Card, _extends({}, rest, {
    className: cn(styles.root, className)
  }, linkTo ? {
    as: Link,
    to: linkTo
  } : {}, {
    highlightOnHover: !!linkTo
  }));
}